import { PricingModel } from 'src/common/external/bambi-api/bambiApi';

import { useSelectedPricingModelId } from './useSelectedPricingModelId';

export function useIsPricingModelSelected(pricingModel: PricingModel) {
  const selectedPricingModelId = useSelectedPricingModelId();
  return pricingModel.id === selectedPricingModelId;
}
